import React, { useState, useEffect } from "react";
import { Container, Col, Row, Card, Button, Modal } from "react-bootstrap";
import cinstance from "../../Service/randomcinstance";
import web3 from "../../Service/web3";
import axios from "axios";
import NavBar from "../../Components/NavBar";
import LotteryCard from "../../Components/mine-card/MineCard";

const AllMissilelottery = (props) => {
  const [loading, setLoading] = useState(true);
  const [lotteryList, setLotteryList] = useState([]);
  const [partnerLists, setPartnerLists] = useState([]);
  const [partnerLogoData, setPartnerLogoData] = useState([]);
  const apiUrl = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    let isCancelled = false;
    const getLotteryList = async () => {
      setLoading(true);
      try {
        if (window.ethereum) {
          window.web3 = web3;
        }

        const totalIdsRaw = await cinstance.methods.lotteryId().call();
        const totalIds = Number(totalIdsRaw || 0);
        const lotteryCalls = [];

        for (let i = 1; i <= totalIds; i++) {
          lotteryCalls.push(
            cinstance.methods
              .lottery(i)
              .call()
              .catch((err) => {
                console.log("lottery", i, err);
                return null;
              })
          );
        }

        const lotteryResults = await Promise.all(lotteryCalls);
        const filteredLotteries = lotteryResults
          .filter(
            (response) =>
              response &&
              (response.status === "0" ||
                response.status === "3" ||
                response.status === "5") &&
              Number(response.lotteryType) === 3
          )
          .sort((a, b) => Number(b.lotteryId) - Number(a.lotteryId));

        const uniquePartners = [
          ...new Set(
            filteredLotteries
              .map((item) => item.partnerAddress)
              .filter((addr) => addr && addr !== "0x0000000000000000000000000000000000000000")
          ),
        ];

        const partnerResults = await Promise.all(
          uniquePartners.map((addr) =>
            cinstance.methods
              .partnerbyaddr(addr)
              .call()
              .catch((err) => {
                console.log("error", err);
                return null;
              })
          )
        );

        if (!isCancelled) {
          setLotteryList(filteredLotteries);
          setPartnerLists(partnerResults.filter(Boolean));
        }
      } catch (err) {
        console.log("res", err);
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }

      if (apiUrl) {
        axios
          .get(`${apiUrl}/s3imageupload/getAllPartnerLogos`)
          .then((response) => {
            if (!isCancelled) {
              const partnerData = response?.data?.result || response?.data || [];
              setPartnerLogoData(Array.isArray(partnerData) ? partnerData : []);
            }
          })
          .catch((err) => {
            console.log("logos err", err);
          });
      }
    };

    getLotteryList();

    return () => {
      isCancelled = true;
    };
  }, [apiUrl]);

  // const mergeArray = (lotteryList, partnerLists, prop) => {
  //   partnerLists?.forEach((partnerlistsElement) => {
  //     const { status, ...partnerlistsElementWithoutStatus } =
  //       partnerlistsElement;
  //     const lotterylistElement = lotteryList.find((lotterylistElement) => {
  //       return partnerlistsElement[prop] === lotterylistElement[prop];
  //     });
  //     if (lotterylistElement) {
  //       Object.assign(lotterylistElement, partnerlistsElementWithoutStatus);
  //       lotterylistElement.partnerStatus = status;
  //     } else {
  //       lotteryList.push({
  //         ...partnerlistsElementWithoutStatus,
  //         partnerStatus: status,
  //       });
  //     }
  //   });
  // };

  // mergeArray(lotteryList, partnerLists, "partnerAddress");

  const findPartnerByAddress = (address, partnerList) => {
    return (
      partnerList?.find((partner) => partner.partnerAddress === address) || {}
    );
  };

  return (
    <div fluid className="p-0 m-0 allLottery">
      <NavBar />
      <Container>
        <div className="mx-auto mt-3 ">
          <Row className="lottery-section">
            <Col>
              <h2
                className="section-title"
                style={{ fontWeight: "600", fontSize: "28px" }}
              >
                Autobet Missile
              </h2>
            </Col>
          </Row>
          <Row className="mx-auto lottery-section2 text-center">
            {loading && <h4 className="spacingleft">Loading lotteries...</h4>}
            {!loading && lotteryList.length === 0 && (
              <h4 className="spacingleft">No Active Lotteries !</h4>
            )}
            {lotteryList.map((item, index) => {
              const partnerData = findPartnerByAddress(
                item.partnerAddress,
                partnerLists
              );
              return (
                <Col lg={4}>
                  <LotteryCard
                    key={index}
                    history={props.history}
                    item={item}
                    lotteryType={"missile"}
                    partner={partnerData}
                    partnerLogo={partnerLogoData}
                  />
                </Col>
              );
            })}
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default AllMissilelottery;
